export default "__VITE_ASSET__yw_kECW0__"